export const en = {
    interfaces: {
        list: {
            interfaceId: "Interface Identifier",
            name: "Name",
            entity: "Entity",
            profile: "Profile",
            status: "Status",
            lastCommunication: "Last Communication",
            dataType: "Data Type",
            category: "Category",
            lastReading: "Last Reading",
            lastReadingWithUnits: "Last Reading With Units",
            historyConfiguration: "History Configuration",
            unitType: "Unit Type",
            entityId: "Entities"
        },
        dataTypes: {
            metadata: "Metadata",
            string: "String",
            numeric: "Numeric",
            boolean: "Boolean"
        },
        historyConfiguration: {
            noHistory: "No History",
            differentValues: "Different Values",
            allValues: "All Values"
        },
        interfaceType: {
            input: "Input",
            output: "Output",
            inputOutput: "Input/Output"
        },
        unitTypes: {
            CELSIUS: 'Celsius',
            PEOPLE: 'People'
        },
        interfaceCategories: {
            PEOPLE_COUNTER: 'People Counter',
            TEMPERATURE: 'Temperature',
            SWITCH: 'Switch',
            SYSTEM: 'System'
        },
        alerts: {
            create: {
                title: "Create Interface",
                text: "Are you sure you want to create <b>%{interface}</b>",
                success: {
                    title: "Interface Created Successfully",
                    text: "<b>%{interface}</b> was created successfully",
                },
                error: {
                    title: "Interface Create Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            delete: {
                title: "Delete Interface",
                text: "Are you sure you want to delete <b>%{interface}</b>",
                success: {
                    title: "Interface Deleted Successfully",
                    text: "You will now be redirected to the interfaces page",
                },
                error: {
                    title: "Interface Delete Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            edit: {
                title: "Edit Interface",
                text: "Are you sure you want to edit <b>%{interface}</b>",
                success: {
                    title: "Interface Edited Successfully",
                    text: "<b>%{interface}</b> was edited successfully",
                },
                error: {
                    title: "Interface Edit Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        form: {
            headers: {
                create: "Create Interface",
                edit: "Edit Interface",
                view: "View Interface"
            },
            interfaceIdentifier: {
                label: "Interface Identifier",
            },
            name: {
                label: "Name",
            },
            dataType: {
                label: "Data Type",
            },
            historyConfiguration: {
                label: "History Configuration",
            },
            historyMaxAge: {
                label: "History Maximum Age",
            },
            unitType: {
                label: "Unit Type",
            },
            category: {
                label: "Category",
            },
            interfaceType: {
                label: "Interface Type",
            },
            lastReading: {
                label: "Last Reading",
            },
            lastCommunication: {
                label: "Last Communication",
            }
        },
        associatedEntities: {
            header: "Associated entities list",
            name: "Name",
            type: "Type",
        },
        errors: {
            invalidHistoryMaxAge: "Invalid History Maximum Age Format",
        },
        permissions: {
            INTERFACES: "Interfaces",
            CREATE_INTERFACE: "Create interface",
            READ_INTERFACE: "Read interface",
            UPDATE_INTERFACE: "Update interface",
            DELETE_INTERFACE:"Delete interface",
            CHANGE_INTERFACE_READING:"Change interface reading",
            REQUEST_INTERFACE_READING:"Request interface reading"
        }
    }
};